<p class="text">
  V{{ version.version }} © {{ "GLOBAL.ALL_RIGHTS_RESERVED" | translate }}
  {{ version.year }}
</p>
